import _ from 'lodash';

export default class FakeTwilio {
  destroy() {
    this.deviceIsDestroyed = true;
  }

  disconnectAll() {
    this.deviceDisconnected = true;
  }

  on(event, callback) {
    this[`${event}Callback`] = callback;
  }

  status() {
    return 'ready';
  }

  register() {
    this.registered = true;
  }

  updateToken(token) {
    this.token = token;
  }

  updateOptions(options) {
    this.options = options;
  }

  simulateIncomingCall() {
    let connection = {
      accept: this.onClientAccept || _.noop,
      disconnect: this.onClientDisconnect || _.noop,
      on: _.noop,
      reject: _.noop,
      sendDigits: _.noop,
      status: () => 'open',
    };
    this.incomingCallback(connection);
  }
}
